import React, { useState } from 'react';
import { Captcha } from './Captcha';
interface ContactFormProps {
  defaultTopic?: string;
}
const TOPICS = ['Question', 'Review', 'Complaint', 'Request to Delete Account', 'Trial Class / Program Info', 'Summer Camp', 'Billing / Payment Question'] as const;
export function ContactForm({
  defaultTopic = ''
}: ContactFormProps) {
  const [captchaValid, setCaptchaValid] = useState(false);
  return (
    // NOTE: This is a placeholder front-end submission for the Magic Patterns
    // preview. In production, replace with the live WebsiteForge contact form
    // embed so submissions hit Storm Taekwondo's real inbox/CRM.
    <form action="/thank-you-free-trial" method="get" className="bg-paper p-8 md:p-10 rounded-2xl shadow-xl border border-subtle-gray w-full" data-id="element-166">
      <div className="grid sm:grid-cols-2 gap-5 mb-5" data-id="element-167">
        <div data-id="element-168">
          <label htmlFor="firstName" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-169">
            First Name
          </label>
          <input type="text" id="firstName" name="firstName" required autoComplete="given-name" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="Jane" data-id="element-170" />
        </div>
        <div data-id="element-171">
          <label htmlFor="lastName" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-172">
            Last Name
          </label>
          <input type="text" id="lastName" name="lastName" required autoComplete="family-name" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="Doe" data-id="element-173" />
        </div>
      </div>

      <div className="mb-5" data-id="element-174">
        <label htmlFor="email" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-175">
          Email
        </label>
        <input type="email" id="email" name="email" required autoComplete="email" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="email@example.com" data-id="element-176" />
      </div>

      <div className="mb-5" data-id="element-177">
        <label htmlFor="phone" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-178">
          Phone Number
        </label>
        <input type="tel" id="phone" name="phone" required autoComplete="tel" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="(517) 220-0621" data-id="element-179" />
      </div>

      <div className="mb-5" data-id="element-180">
        <label htmlFor="topic" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-181">
          Select a Topic
        </label>
        <select id="topic" name="topic" required defaultValue={defaultTopic} className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" data-id="element-182">
          <option value="" disabled data-id="element-183">
            Choose a topic
          </option>
          {TOPICS.map(t => <option key={t} value={t} data-id="element-184">
              {t}
            </option>)}
        </select>
      </div>

      <div className="mb-6" data-id="element-185">
        <label htmlFor="message" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-186">
          Message
        </label>
        <textarea id="message" name="message" required rows={5} className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all resize-y" placeholder="Tell us a little about what you're looking for..." data-id="element-187" />
      </div>

      <div className="mb-6" data-id="element-188">
        <Captcha onValidChange={setCaptchaValid} data-id="element-189" />
      </div>

      <button type="submit" disabled={!captchaValid} className="btn-primary w-full mb-4 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-190">
        Send Message
      </button>
      <p className="text-xs text-gray-warm text-center leading-relaxed" data-id="element-191">
        We typically reply within one business day. For faster help, call{' '}
        <a href="tel:517-220-0621" className="font-bold text-storm-red hover:underline" data-id="element-192">
          517-220-0621
        </a>{' '}
        or email{' '}
        <a href="mailto:info@stormtaekwondo.com" className="font-bold text-storm-red hover:underline" data-id="element-193">
          info@stormtaekwondo.com
        </a>
        .
      </p>
    </form>
  );
}